<template>
  <div>
    <SGPModalComponent
      v-if="true"
      :tamanho="tamanho"
      :titulo="titulo"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <a :href="url" target="_blank" title="Abrir em nova guia">
          <figcaption class="mdn-Shortcut-text">Click para visualizar em nova guia.</figcaption>
          <img class="img-responsive" :src="url" style="width:750px; height:auto;"/>
      </a>
    </SGPModalComponent> 
  </div>
</template>

<script>

export default {
  name: 'SGPModalImagemComponent',

  props: {
    titulo: {
      type: String,
      required: true,
      default: ''
    },
    url: {
      type: String,
      required: true,
    },
    legenda: {
      type: String,
      default: ''
    },
    tamanho: {
      type: String,
      required: false,
      default: 'xg'
    },
    mostrarHeader: {
      type: Boolean,
      required: false,
      default: true
    },
    mostrarBody: {
      type: Boolean,
      required: false,
      default: true
    },
    mostrarFooter: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    return {
      mostrarModal: false
    }
  },

  mounted () {
    this.mostrarModal = true
  },

  methods: {
    fecharModal () {
      this.mostrarModal = false
      setTimeout( () => {
        this.$emit('sgpModalFechar')
      }, 300)      
    }
  }
}
</script>